export const AUTH_PENDING_ACTION_ENUM = {
  EMAIL_VERIFICATION: 'EMAIL_VERIFICATION',
  PHONE_VERIFICATION: 'PHONE_VERIFICATION',
  SECOND_FACTOR: 'SECOND_FACTOR',
  AWAITING_VALIDATION: 'AWAITING_VALIDATION',
} as const;

export type TAuthPendingActionEnum =
  (typeof AUTH_PENDING_ACTION_ENUM)[keyof typeof AUTH_PENDING_ACTION_ENUM];

export const LOGIN_METHOD_ENUM = {
  CLOUDFLARE: 'cloudflare',
};
